import { BASE_API_URL } from "../../config/Api";
import { DAILYUPDATE_ADD, DAILYUPDATE_LIST } from "./ActionType";

export const dailyUpdateList=(fromDate,toDate,loginId,token,pageSize,pageNumber)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/fetchEmployeeDailyWorkDetailsDateWise?fromDate=${fromDate}&toDate=${toDate}&loginId=${loginId}&pageSize=${pageSize}&pageNo=${pageNumber}`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        })
        const resData=await res.json();
        dispatch({type:DAILYUPDATE_LIST, payload:resData})
    } catch (error) {
       
    }
}


export const dailyUpdateAdd=(dailyUpdateData,token)=>async(dispatch)=>{
    try {
        const res=await fetch(`${BASE_API_URL}/addDailyWorkDetails`,{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(dailyUpdateData),

        })
        const resData=await res.json();
        if (res.ok && resData.statusCode === "00") {
            dispatch({ type: DAILYUPDATE_ADD, payload: resData });
            return { success: true };
          } else {
            return { success: false, error: resData.message || 'An unknown error occurred' };
          }
    } catch (error) {
        
    }
}
